"use client";
import React from "react";
import { Box, Container, Typography } from "@mui/material";
import LogoLoop from "../components/LogoLoop/LogoLoop";
import { IMAGES } from "../constants/images";
import { useTranslation } from "react-i18next";

const ZaynCourasel = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const logoImages = [
    {
      src: IMAGES.GRAY_LOGO_1,
      alt: "Companies using AI recruiting tool and AI interview platform",
    },
    {
      src: IMAGES.GRAY_LOGO_2,
      alt: "Companies using AI recruiting tool and AI interview platform",
    },
    {
      src: IMAGES.GRAY_LOGO_3,
      alt: "Companies using AI recruiting tool and AI interview platform",
    },
    {
      src: IMAGES.GRAY_LOGO_4,
      alt: "Companies using AI recruiting tool and AI interview platform",
    },
    {
      src: IMAGES.GRAY_LOGO_5,
      alt: "Companies using AI recruiting tool and AI interview platform",
    },
    {
      src: IMAGES.GRAY_LOGO_6,
      alt: "Companies using AI recruiting tool and AI interview platform",
    },
    {
      src: IMAGES.GRAY_LOGO_7,
      alt: "Companies using AI recruiting tool and AI interview platform",
    },
  ];

  return (
    <Container
      maxWidth="xxl"
      sx={{
        mt: { xs: "1%", md: "2.5%", lg: "2%" },
        direction: isArabic ? "rtl" : "ltr",
      }}
    >
      {/* Title */}
      <Typography
        sx={{
          fontFamily: "var(--font-outfit)",
          color: "#435268",
          fontSize: { xs: "18px", md: "23px" },
          fontWeight: 400,
          textAlign: "center",
          mx: "auto",
          mb: "2%",
        }}
      >
        {t("zaynCarousel.title")}
      </Typography>

      {/* Carousel wrapper - always LTR to keep scroll direction correct */}
      <Box
        sx={{
          width: "100%",
          position: "relative",
          overflow: "hidden",
          mt: { xs: "10%", lg: "1%" },
          direction: "ltr", // ← yeh fix hai
        }}
      >
        {/* Left Fade */}
        <Box
          sx={{
            position: "absolute",
            left: 0,
            top: 0,
            bottom: 0,
            width: { xs: "60px", sm: "100px", md: "150px", lg: "200px" },
            background:
              "linear-gradient(to right, rgba(255,255,255,1) 0%, rgba(255,255,255,0.8) 30%, rgba(255,255,255,0) 100%)",
            zIndex: 2,
          }}
        />

        {/* Right Fade */}
        <Box
          sx={{
            position: "absolute",
            right: 0,
            top: 0,
            bottom: 0,
            width: { xs: "60px", sm: "100px", md: "150px", lg: "200px" },
            background:
              "linear-gradient(to left, rgba(255,255,255,1) 0%, rgba(255,255,255,0.8) 30%, rgba(255,255,255,0) 100%)",
            zIndex: 2,
          }}
        />

        {/* Mobile */}
        <Box sx={{ display: { xs: "block", md: "none" } }}>
          <LogoLoop
            logos={logoImages}
            speed={90}
            direction="left"
            logoHeight={45}
            gap={50}
            pauseOnHover
            scaleOnHover
            fadeOut
            fadeOutColor="#ffffff"
            ariaLabel="Trusted Company Logos"
          />
        </Box>

        {/* Desktop */}
        <Box sx={{ display: { xs: "none", md: "block" } }}>
          <LogoLoop
            logos={logoImages}
            speed={90}
            direction="left"
            logoHeight={70}
            gap={80}
            pauseOnHover
            scaleOnHover
            fadeOut
            fadeOutColor="#ffffff"
            ariaLabel="Trusted Company Logos"
          />
        </Box>
      </Box>
    </Container>
  );
};

export default ZaynCourasel;
